import { Apartment, Business, Home, Landscape } from "@mui/icons-material";
import SwitcherChild from "./switcher-child";
import styles from "./switcher.module.css";
import { useEdittingStore } from "../context/useEdittingStore";
import { TypeEnum } from "@/types/types";

export default function Switcher({
  apartamentPlaceholder,
  housePlaceholder,
  landPlaceholder,
  officePlaceholder,
}: {
  apartamentPlaceholder: string;
  housePlaceholder: string;
  landPlaceholder: string;
  officePlaceholder: string;
}) {
  const type = useEdittingStore((state) => state.listing.type);
  const setField = useEdittingStore((state) => state.setField);
  return (
    <div id="type" className={styles.switcherWrapper}>
      <SwitcherChild
        text={apartamentPlaceholder}
        icon={<Apartment />}
        isActive={type === TypeEnum.APARTMENT}
        onClick={() => {
          setField("type", TypeEnum.APARTMENT);
          setField("category", null);
          setField("building_type", null);
          setField("office_type", null);
        }}
      />
      <SwitcherChild
        text={housePlaceholder}
        icon={<Home />}
        isActive={type === TypeEnum.HOUSE}
        onClick={() => {
          setField("type", TypeEnum.HOUSE);
          setField("category", null);
          setField("building_type", null);
          setField("office_type", null);
        }}
      />
      <SwitcherChild
        text={landPlaceholder}
        icon={<Landscape />}
        isActive={type === TypeEnum.LAND}
        onClick={() => {
          setField("type", TypeEnum.LAND);
          setField("category", null);
          setField("building_type", null);
          setField("office_type", null);
        }}
      />
      <SwitcherChild
        text={officePlaceholder}
        icon={<Business />}
        isActive={type === TypeEnum.OFFICE}
        onClick={() => {
          setField("type", TypeEnum.OFFICE);
          setField("category", null);
          setField("building_type", null);
          setField("office_type", null);
        }}
      />
    </div>
  );
}
